import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CDMD_TOTAL_CUPOS } from '../../../../../config/tables'

function TablaDetalleTotalCupoView () {
  return (
    <MuiTable id={TABLA_CDMD_TOTAL_CUPOS} />
  )
}
export default TablaDetalleTotalCupoView
